import { createElement } from '@syncfusion/ej2-base';
import { ActionInfo } from '@syncfusion/ej2-documenteditor';

/**
 * Represents document editor title bar.
 */
export class TitleBar {
    private tileBarDiv: HTMLElement;
    private badgeElement: HTMLElement;
    private userList?: HTMLElement;
    public userMap: any = {};

    constructor(element: HTMLElement, badgeElement: HTMLElement) {
        //initializes title bar elements.
        this.tileBarDiv = element;
        this.badgeElement = badgeElement;
        this.initializeTitleBar();
    }

    private initializeTitleBar = (): void => {
        //User info div
        this.userList = createElement('div', { id: 'de_userInfo', styles: 'float:right;margin-top: 3px;' });
        this.tileBarDiv.appendChild(this.userList);
        this.badgeElement.innerText = ' 1 ';
    }

    public getUserCount(): number {
        return this.userMap.length;
    }

    public addUser(actionInfos: ActionInfo | ActionInfo[]): void {
        if (!(actionInfos instanceof Array)) {
            actionInfos = [actionInfos]
        }
        for (let i: number = 0; i < actionInfos.length; i++) {
            let actionInfo: ActionInfo = actionInfos[i];
            if (this.userMap[actionInfo.connectionId as string]) {
                continue;
            }
            let avatar: HTMLElement = createElement('div', { className: 'e-avatar e-avatar-xsmall e-avatar-circle', styles: 'margin: 0px 5px', innerHTML: this.constructInitial(actionInfo.currentUser as string) });
            avatar.title = actionInfo.currentUser as string;
            if (this.userList) {
                this.userList.appendChild(avatar);
            }
            this.userMap[actionInfo.connectionId as string] = avatar;
        }
        if (this.userList)
            this.badgeElement.innerText = ' ' + (this.userList.childElementCount + 1).toString() + ' ';
    }

    public removeUser(conectionId: string): void {
        if (this.userMap[conectionId]) {
            if (this.userList) {
                this.userList.removeChild(this.userMap[conectionId]);
            }
            delete this.userMap[conectionId];
        }
        if (this.userList)
            this.badgeElement.innerText = ' ' + this.userList.childElementCount.toString() + ' ';
    }

    private constructInitial(authorName: string): string {
        const splittedName: string[] = authorName.split(' ');
        let initials: string = '';
        for (let i: number = 0; i < splittedName.length; i++) {
            if (splittedName[i].length > 0 && splittedName[i] !== '') {
                initials += splittedName[i][0];
            }
        }
        return initials;
    }
    
}